export const PUBLISH_CONTENT_TYPES = {
  BANNER: 'banner',
  TEMPLATE: 'template',
  PAGES: 'PAGES',
  CATEGORIES: 'CATEGORIES',
  WIDGETS: 'WIDGETS',
  SEO: 'SEO',
  INFORMATION_POLICY: 'INFORMATION_POLICY',
  ADMIN_SETTINGS: 'ADMIN_SETTINGS',
  CONFIG_SETTINGS: 'CONFIG_SETTINGS',
  TAX_CATEGORY: 'TAX_CATEGORY',
  EMPLOYER: 'EMPLOYER',
  BRANCH: 'BRANCH',
  STAFF: 'STAFF',
  SHIFT: 'SHIFT',
  TRANSACTION: 'TRANSACTION',
  SHIFT_APPLICATION: 'SHIFT_APPLICATION',
  TIMESHEET: 'TIMESHEET',
  STAFF_DOCUMENTS: 'STAFF_DOCUMENTS',
  STAFF_AVAILABILITY: 'STAFF_AVAILABILITY',
};
